import config from 'config';
import { WidgetInstance } from 'friendly-challenge';
import React, { useEffect, useRef } from 'react';

type OwnProps = {
	doneCallback?: (solution: string) => void;
	errorCallback?: (error: any) => void;
};

const FriendlyCaptcha: React.FC<OwnProps> = (props) => {
	const container = useRef<HTMLDivElement | null>(null);
	const widget = useRef<WidgetInstance | null>(null);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	useEffect(() => {
		if (!widget.current && container.current) {
			widget.current = new WidgetInstance(container.current, {
				startMode: 'auto',
				doneCallback: props.doneCallback,
				errorCallback: props.errorCallback,
			});
		}

		return () => {
			if (widget.current !== null) widget.current.destroy();
		};
	}, [container]);

	return (
		<div
			ref={container}
			data-sitekey={config.friendlyCaptchaSiteKey}
			data-lang="de"
			className="frc-captcha"
		/>
	);
};

export default FriendlyCaptcha;
